import React from "react";
import Building from "../Asset/Building.webp";
import { Container, Row, Col, Card } from "react-bootstrap";

function About() {
  return (
    <div
      style={{
        background: "#f8f9fa",
        minHeight: "100vh",
        paddingBottom: "40px"
      }}
    >
      <Container>

        {/* Page Title */}
        <div className="text-center pt-4 mb-4">
          <h2 className="fw-bold">About Us</h2>
          <p className="text-muted">
            A digital temple directory connecting devotees with sacred places
          </p>
        </div>

        {/* About Project */}
        <Card className="shadow mb-4 border-0" style={{ border: '0px solid gray' }}>
          <Card.Body>
            <Row className="align-items-center" style={{ border: '0px solid gray' }}>

              {/* Left Side Image */}
              <Col md={5} sm={12} className="mb-4 mb-md-0 text-center" style={{ border: '0px solid gray' }}>
                <img
                  src={Building}
                  alt="Temple"
                  style={{
                    width: "100%",
                    maxWidth: "450px",
                    height: "400px",
                    objectFit: "cover",
                    borderRadius: "12px",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                    border: '0px solid red'
                  }}
                />
              </Col>

              {/* Right Side Content */}
              <Col
                // md={7} sm={12}
                style={{ border: '0px solid gray', height: '100%', width: '100%', }}>

                {/* <>
                  <h3>Sanmati Engineering College, Washim</h3>
                </> */}

                <p style={{ textAlign: "justify", lineHeight: "1.8" }}>
                  <strong>Sanmati Engineering College, Washim :</strong> Sanmati Engineering College is one of the constituent institutions of Mukund Education Society, founded in academic year 2009-2010. It offers a wide range of graduate programs in the fields of Civil, Mechanical, Electrical, AI&DS and Computer Science Engineering. Each program has an intake of 60 seats. SEC has an excellent infrastructure, well-equipped Laboratories and workshops, state-of-the-art Computer and IT Center, Central Library, spacious auditorium, hygienic Canteen, separate hostels and gym for boys and girls.

                  All the branches of Engineering and Technology have their own technical associations which organize technical meetings, symposia, etc. in their respective disciplines. National level technical symposia are conducted every year. The valuable inputs gained from these help the students to hone their technical, managerial and organizational skills.
                </p>

                {/* <p style={{ textAlign: "justify", lineHeight: "1.8" }}>
                  The Institute has teaching faculty who are well qualified from reputed institutes, carrying experience from teaching as well as industry. Many of them have done eminent research and publication work in their domain of specialization and are very good at imparting knowledge to the students.
                </p> */}


                {/* <p style={{ textAlign: "justify", lineHeight: "1.8" }}>
                  <strong>DARSHANIKA – The Temple Directory</strong> is a digital
                  platform designed to help devotees and visitors easily discover
                  temples and sacred places within a region. The main purpose of
                  this application is to provide reliable and organized information
                  about temples, their history, rituals, facilities, and important
                  events so that devotees can plan their visits comfortably and
                  conveniently.
                </p>

                <p style={{ textAlign: "justify", lineHeight: "1.8" }}>
                  This platform acts as a centralized temple information system
                  where users can explore temples, learn about their spiritual
                  significance, view images and videos, and access important details
                  such as temple timings, pooja schedules, festivals, and services
                  provided by temple trusts.
                </p> */}
              </Col>

            </Row>
          </Card.Body>
        </Card>
        {/* Key Features */}
        {/* <h3 className="text-center fw-bold mb-4">
          Team Members
        </h3> */}

        <Row className="g-4">

          {/* Guide */}

          {/* Priyanka */}
          {/* <Col md={4} sm={6}>
            <Card className="shadow h-100 text-center p-3">
              <Card.Body>
                <h5 className="fw-bold">Miss.Priyanka Wankhede</h5>
                <p>
                  MERN stack developer with strong skills in creating responsive and user-friendly interfaces.
                  Handle frontend and designing.
                  Focused on delivering clean, attractive, and efficient web experiences.
                </p>
                <a
                  href="https://www.linkedin.com/in/priyankawankhede2004?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                  target="_blank"
                  rel="noreferrer"
                  className="team-link-btn"
                >
                  LinkedIn
                </a>
              </Card.Body>
            </Card>
          </Col> */}
          {/* Pankaj */}
          <Col md={12} sm={4}>
            <Card className="shadow h-100 text-center p-3" style={{ maxWidth: '100%' }}>
              <Card.Body>
                <h3 className="fw-bold">Address</h3>
                <p className="fw-bold">
                  Sanmati Engineering College,

                </p>
                <p className="fw-bold">
                  NH161, Washim-Malegaon Road, Sawargaon Barde, Washim 444505

                </p>
                <a
                  href="https://www.sanmati.edu.in/"
                  target="_blank"
                  rel="noreferrer"
                  className="team-link-btn"
                >
                  Website
                </a>
              </Card.Body>
            </Card>
          </Col>

          {/* Nisarga */}
          {/* <Col md={4} sm={6}>
            <Card className="shadow h-100 text-center p-3">
              <Card.Body>
                <h5 className="fw-bold">Miss.Nisarga Lahe</h5>
                <p>
                  Responsible for preparing and maintaining project documentation.
                  Ensures all project details are clearly structured and well-presented.
                </p>
                <a
                  href="https://www.linkedin.com/in/nisarga-lahe-726b06239?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                  target="_blank"
                  rel="noreferrer"
                  className="team-link-btn"
                >
                  LinkedIn
                </a>
              </Card.Body>
            </Card>
          </Col> */}

          {/* Ganesh */}
          {/* <Col md={4} sm={6}>
            <Card className="shadow h-100 text-center p-3">
              <Card.Body>
                <h5 className="fw-bold">Mr.Ganesh Zamre</h5>
                <p>
                  Handled data collection and ensured proper documentation of information.
                  Organized and analyzed data for better project insights.
                  Maintains accuracy and consistency in collected data.
                </p>
                <a
                  href="https://www.linkedin.com/in/ganesh-zamre-webdeveloper?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                  target="_blank"
                  rel="noreferrer"
                  className="team-link-btn"
                >
                  LinkedIn
                </a>
              </Card.Body>
            </Card>
          </Col> */}

          {/* Aditi */}
          {/* <Col md={4} sm={6}>
            <Card className="shadow h-100 text-center p-3">
              <Card.Body>
                <h5 className="fw-bold">Miss.Aditi Chavhan</h5>
                <p>
                  Assisted in data collection and management throughout the project.
                  Ensured all required information is properly maintained and updated.
                </p>
                <a
                  href="https://www.linkedin.com/in/aditi-chavhancloudaws?utm_source=share_via&utm_content=profile&utm_medium=member_android"
                  target="_blank"
                  rel="noreferrer"
                  className="team-link-btn"
                >
                  LinkedIn
                </a>
              </Card.Body>
            </Card>
          </Col> */}

          {/* <Col md={4} sm={6}>
            <Card className="shadow h-100 text-center p-3 border border-dark">
              <Card.Body>
                <h5 className="fw-bold">Dr.S.A.Vyawhare </h5>
                <p>
                  Provided guidance and direction throughout the project development.
                  Helped in shaping the project idea and overall execution.

                </p>
                <a
                  href="https://linkedin.com/in/guide-linkedin"
                  target="_blank"
                  rel="noreferrer"
                  className="team-link-btn"
                >
                  LinkedIn
                </a>
              </Card.Body>
            </Card>
          </Col> */}

          {/* Co-Guide */}
          {/* <Col md={4} sm={6}>
      <Card className="shadow h-100 text-center p-3 border border-dark">
        <Card.Body>
          <h5 className="fw-bold">Prof.N.M.Gore</h5>
          <p>
            Supported the team in coding and designing aspects.
Provided technical guidance and problem-solving strategies.
          </p>
          <a
            href="https://linkedin.com/in/coguide-linkedin"
            target="_blank"
            rel="noreferrer"
            className="team-link-btn"
          >
            LinkedIn
          </a>
        </Card.Body>
      </Card>
    </Col> */}

        </Row>

      </Container>
    </div>
  );
}

export default About;